<template>
  <d-page-layout :hasSearch="false">
    <template slot="heading">
      <v-breadcrumbs
        v-if="!loading"
        class="pa-0"
        :items="items"
      ></v-breadcrumbs>
    </template>
    <template slot="content">
      <d-loading class="mb-4" v-if="loading"></d-loading>
      <template v-else>
        <v-row>
          <v-col cols="12" md="4" class="mb-3">
            <h6 class="subtitle-1 font-weight-bold gray--text text--darken-2">
              {{ $t("project-apis.add.form.name") }}:
            </h6>
            <p class="mb-0">{{ api.name }}</p>
          </v-col>

          <v-col cols="12" md="8" class="mb-3">
            <h6 class="subtitle-1 font-weight-bold gray--text text--darken-2">
              {{ $t("project-apis.add.form.description") }}:
            </h6>
            <p class="mb-0">{{ api.description }}</p>
          </v-col>
        </v-row>
        <BaseLog :getLogs="getLogs"></BaseLog>
      </template>
    </template>
  </d-page-layout>
</template>
    <script>
import BaseLog from "@/components/BaseLog/BaseLog.vue";
import {
  getProjectApiById,
  getProjectApiLogs,
  getProjectById,
} from "@/services/project";

export default {
  components: {
    BaseLog,
  },
  data: (vm) => ({
    items: [
      {
        text: vm.$t("projects.page-heading"),
        disabled: false,
        to: "/projects",
      },
      {
        text: "",
        disabled: false,
        href: null,
      },
      {
        disabled: true,
        text: "",
        href: null,
      },
      {
        text: vm.$t("project-apis.text.logs"),
        disabled: true,
      },
    ],
    api: null,
    loading: true,
    project: null,
  }),
  methods: {
    getLogs() {
      return getProjectApiLogs(
        this.$route.params.projectId,
        this.$route.params.apiId
      );
    },
  },
  async created() {
    try {
      this.loading = true;
      this.project = await getProjectById(this.$route.params.projectId).then(
        (res) => res.data
      );

      this.api = await getProjectApiById({
        projectId: this.$route.params.projectId,
        id: this.$route.params.apiId,
      }).then((res) => res.data);

      this.items[1].text = this.project?.name;
      this.items[1].href = `/project/${this.$route.params.projectId}/apis`;

      this.items[2].text = this.api?.name;

      await this.$eventBus.$emit("fetchLogs");
    } finally {
      this.loading = false;
    }
  },
};
</script>
    